import { Group, SaveButton } from '@/components/_common';
import {
  useFinancialMatrixSettings,
  useFinancialMatrixSettingsCreate,
  useFinancialMatrixSettingsUpdate,
} from '@/core/domain/enterprise/MatrixFinancialSettings/MatrixFinancialSettings.hooks';
import {
  FinancielMatrixBankSlipOrientation,
  FinancielMatrixBankSlipOrientationLabel,
} from '@/core/domain/enterprise/MatrixFinancialSettings/MatrixFinancialSettings.types';
import { useWindowSize } from '@/hooks';
import { initialTabErrors } from '@/pages/SettingsPages/FinancialSettingsPage';
import { Checkbox, Col, Divider, Form, Radio, Row, Typography } from 'antd';
import { useEffect } from 'react';

const { Title } = Typography;

interface Props {
  handleTabError(key: keyof typeof initialTabErrors): void;
  menuActive: boolean;
}

interface FormValues {
  bankSlipPaidBeforeDueDate: boolean;
  autoSettleOnBankSlipPayment: boolean;
  bankSlipOrientation: FinancielMatrixBankSlipOrientation;
}

export default function BankSlipConfiguration({ menuActive }: Props) {
  const { width } = useWindowSize();
  const [form] = Form.useForm<FormValues>();
  const financialSettings = useFinancialMatrixSettings(menuActive);
  const financialSettingsUpdate = useFinancialMatrixSettingsUpdate();
  const financialSettingsCreate = useFinancialMatrixSettingsCreate();

  useEffect(() => {
    if (financialSettings.data) {
      form.setFieldsValue({
        bankSlipPaidBeforeDueDate:
          financialSettings.data.bankSlipPaidBeforeDueDate,
        autoSettleOnBankSlipPayment:
          financialSettings.data.autoSettleOnBankSlipPayment,
        bankSlipOrientation: financialSettings.data.bankSlipOrientation,
      });
    }
  }, [menuActive, financialSettings.dataUpdatedAt]);

  async function handleSubmit() {
    const values = await form.validateFields();

    if (financialSettings.data?.id) {
      await financialSettingsUpdate.mutateAsync({
        ...values,
        id: financialSettings.data?.id,
      });
    } else {
      await financialSettingsCreate.mutateAsync(values);
    }
  }

  return (
    <>
      <Group position="between">
        <Title level={width < 576 ? 5 : 4}>Boleto</Title>

        <SaveButton onClick={handleSubmit}>Salvar</SaveButton>
      </Group>

      <Divider />

      <Form form={form} layout="vertical">
        <Row>
          <Col span={12}>
            <Form.Item
              name="bankSlipPaidBeforeDueDate"
              initialValue={false}
              valuePropName="checked"
              noStyle
            >
              <Checkbox>
                Parcelas serão liquidadas apenas se os boletos forem pagos antes
                da data de vencimento.
              </Checkbox>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="autoSettleOnBankSlipPayment"
              initialValue={false}
              valuePropName="checked"
              noStyle
            >
              <Checkbox>
                Habilitar liquidação automática de parcelas após pagamento do
                boleto
              </Checkbox>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="bankSlipOrientation"
              label="Orientação da impressão"
              style={{ marginTop: 20 }}
            >
              <Radio.Group buttonStyle="solid">
                <Radio.Button
                  value={FinancielMatrixBankSlipOrientation.LANDSCAPE}
                >
                  {
                    FinancielMatrixBankSlipOrientationLabel[
                      FinancielMatrixBankSlipOrientation.LANDSCAPE
                    ]
                  }
                </Radio.Button>
                <Radio.Button
                  value={FinancielMatrixBankSlipOrientation.PORTRAIT}
                >
                  {
                    FinancielMatrixBankSlipOrientationLabel[
                      FinancielMatrixBankSlipOrientation.PORTRAIT
                    ]
                  }
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
